<template>
  <b-card :no-body="true" footer-class="px-3 py-1">
    <b-card-body class="p-2 clearfix">
      <i :class="icon" class="bg-primary p-3 font-2xl mr-3 float-left"></i>
      <div class="h5 text-primary mb-0 mt-2">{{ counter ? counter : 0 }}</div>
      <div class="text-muted text-uppercase font-weight-bold font-xs">{{ subject }}</div>
    </b-card-body>
    <div slot="footer">
      <router-link :to="{path: link}" :title="title" class="font-weight-bold font-xs btn-block text-muted" push>
        Vai all'elenco <i class="fa fa-angle-right float-right font-lg"></i>
      </router-link>
    </div>
  </b-card>
</template>

<script>
export default {
  props: {
    counter: {
      type: String
    },
    subject: {
      type: String
    },
    link: {
      type: String
    },
    title: {
      type: String
    },
    icon: {
      type: String
    }
  }
}
</script>

<style scoped>
  a{
    text-decoration: none;
  }
</style>
